import { init as initApm } from '@elastic/apm-rum';

const apm = initApm({
  serviceName: 'bdsub-frontend',
  environment: 'dev',
  serverUrl: 'https://proposals-dev.nomindgap.com/apm'
})

export default apm;